<div [hidden]="!CurrentScreenOption.IsVisible" class="CPQComponent">
  <label [htmlFor]="CurrentScreenOption.ID" [ngClass]="{'invalid' : !CurrentScreenOption.IsValid}">{{CurrentScreenOption.Caption + " " + CurrentScreenOption.Description}}</label>
  <input [value]="CurrentScreenOption.Value"
         [ngModel]="DisplayValue"
         (ngModelChange)="CurrentScreenOption.Value = $event"
         [type]="type"
         (blur)="textOnBlur($event, CurrentScreenOption.AutoContinueMode)"
         [disabled]="!CurrentScreenOption.IsEnabled"
         [required]="CurrentScreenOption.IsRequired"
         [ngClass]="{'invalid' : !CurrentScreenOption.IsValid}"
         [min]="MinValue"
         [max]="MaxValue"
         />

</div>
